
import { useState, useEffect } from 'react';

/**
 * Определяет, является ли текущее окно «мобильным» (меньше breakpoint).
 *
 * @param {number} breakpoint — ширина в px, ниже которой возвращается true.
 * @returns {boolean} isMobile
 */
export default function useIsMobile(breakpoint = 480) {
  // При SSR window нет — считаем десктопом
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );

  useEffect(() => {
    // В составе effect window уже точно есть
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]); // пересоздаём listener, если изменится breakpoint

  return isMobile;
}
